import React from 'react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import messages from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { Avatars } from './avatars';
import { InviteToEditButton } from './invite-to-edit';
var AvatarsWithPluginState = function AvatarsWithPluginState(props) {
  var title = props.intl.formatMessage(messages.inviteToEditButtonTitle);
  var selected = props.isInviteToEditButtonSelected,
    onClick = props.inviteToEditHandler,
    Component = props.inviteToEditComponent,
    editorView = props.editorView,
    featureFlags = props.featureFlags,
    editorAnalyticsAPI = props.editorAnalyticsAPI,
    editorAPI = props.editorAPI;
  var _useSharedPluginState = useSharedPluginState(editorAPI, ['collabEdit'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    collabEditState = _useSharedPluginState.collabEditState;

  // sessionId
  var sessionIdSelector = useSharedPluginStateSelector(editorAPI, 'collabEdit.sessionId', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var sessionId = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? sessionIdSelector : collabEditState === null || collabEditState === void 0 ? void 0 : collabEditState.sessionId;

  // activeParticipants
  var activeParticipantsSelector = useSharedPluginStateSelector(editorAPI, 'collabEdit.activeParticipants', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var activeParticipants = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? activeParticipantsSelector : collabEditState === null || collabEditState === void 0 ? void 0 : collabEditState.activeParticipants;
  var initialised = useSharedPluginStateSelector(editorAPI, 'collabEdit.initialised', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  if (!collabEditState && editorExperiment('platform_editor_usesharedpluginstateselector', false)) {
    return null;
  }
  if (!initialised && editorExperiment('platform_editor_usesharedpluginstateselector', true)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Avatars, {
    sessionId: sessionId,
    participants: activeParticipants,
    editorView: editorView,
    featureFlags: featureFlags,
    editorAnalyticsAPI: editorAnalyticsAPI,
    editorAPI: editorAPI
  }, /*#__PURE__*/React.createElement(InviteToEditButton, {
    title: title,
    selected: selected,
    onClick: onClick,
    Component: Component
  }));
};
export default injectIntl(AvatarsWithPluginState);